import { getApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  isCompleted: false,
  drawings: [],
  techStandards: [],
  engineeringPrinciples: {
    complyWithTechStandard: '',
    engineeringPrincipleFile: [],
  },
};
const plantDesignDrawingAndTechSlice = createSlice({
  name: 'plantDesignDrawingAndTech',
  initialState,
  reducers: {
    storeIsCompleted(state, action) {
      state.isCompleted = action.payload;
    },
    storeDrawings(state, action) {
      state.drawings = action.payload;
    },
    removeDrawingFile(state, action) {
      state.isCompleted = false;
      state.drawings = state.drawings.map((e, i) => {
        if (i === parseInt(action.payload)) {
          return { ...e, uploadedDocument: undefined };
        } else {
          return e;
        }
      });
    },
    removeDrawing(state, action) {
      state.drawings = state.drawings.filter((e, i) => i !== action.payload);
    },
    storeTechStandards(state, action) {
      state.techStandards = action.payload;
    },
    removeTechStandard(state, action) {
      state.techStandards = state.techStandards.filter((e, i) => i !== action.payload);
    },
    storeEngineeringPrinciples(state, action) {
      state.engineeringPrinciples = action.payload;
    },
    removeEngineeringPrinciplesFile(state, action) {
      state.engineeringPrinciples.engineeringPrincipleFile =
        state.engineeringPrinciples.engineeringPrincipleFile.filter((e) => e.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesignDrawingAndTech };
      });
  },
});

export const {
  storeIsCompleted,
  storeDrawings,
  removeDrawingFile,
  removeDrawing,
  storeTechStandards,
  removeTechStandard,
  storeEngineeringPrinciples,
  removeEngineeringPrinciplesFile,
} = plantDesignDrawingAndTechSlice.actions;
export const plantDesignDrawingAndTechReducer = plantDesignDrawingAndTechSlice.reducer;
